// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pdfviewer[data-v-47638108]{display:inline-block;width:100%}.loading-spinner[data-v-47638108]{margin:10% auto}", ""]);
// Exports
module.exports = exports;
